/* dev-hero-coming-soon.js */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-id]').forEach(section => {
    const sectionId = section.dataset.sectionId;
    const modal = document.querySelector(`[data-section-modal="${sectionId}"]`);
    if (!modal) return;

    const triggerBtn = section.querySelector('[data-modal-trigger]');
    const closeTargets = modal.querySelectorAll('[data-modal-close]');
    const form = modal.querySelector('.hero-coming-soon-modal__form');
    const successEl = modal.querySelector('[data-modal-success]');

    function showSuccess() {
      if (form) form.setAttribute('hidden', '');
      if (successEl) {
        successEl.removeAttribute('hidden');
        requestAnimationFrame(() => successEl.classList.add('is-visible'));
      }
      setTimeout(() => closeModal(), 4000);
    }

    function openModal(withSuccess = false) {
      modal.removeAttribute('hidden');
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      if (withSuccess) {
        showSuccess();
      } else {
        const closeBtn = modal.querySelector('.hero-coming-soon-modal__close');
        if (closeBtn) setTimeout(() => closeBtn.focus(), 80);
      }
    }

    function closeModal() {
      if (modal.classList.contains('is-closing')) return;
      modal.classList.remove('is-open');
      modal.classList.add('is-closing');
      document.body.style.overflow = '';
      const box = modal.querySelector('.hero-coming-soon-modal__box');
      const onEnd = () => {
        box.removeEventListener('animationend', onEnd);
        modal.classList.remove('is-closing');
        modal.setAttribute('hidden', '');
        if (successEl) {
          successEl.classList.remove('is-visible');
          successEl.setAttribute('hidden', '');
        }
        if (form) form.removeAttribute('hidden');
        if (triggerBtn) triggerBtn.focus();
      };
      box.addEventListener('animationend', onEnd);
    }

    // Detect Shopify's return_to redirect after successful newsletter signup
    const params = new URLSearchParams(window.location.search);
    if (params.get('subscribed') === 'true') {
      history.replaceState({}, '', window.location.pathname);
      openModal(true);
    }

    if (triggerBtn) {
      triggerBtn.addEventListener('click', () => openModal());
    }

    closeTargets.forEach(el => {
      el.addEventListener('click', e => {
        e.stopPropagation();
        closeModal();
      });
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden') && !modal.classList.contains('is-closing')) {
        closeModal();
      }
    });

    // Trap focus within modal when open
    modal.addEventListener('keydown', e => {
      if (e.key !== 'Tab' || modal.hasAttribute('hidden') || modal.classList.contains('is-closing')) return;
      const focusable = modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  });
});
